import * as React from 'react';

import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

export interface IListingLayoutProps {
  header: React.ReactElement;
  filters: React.ReactElement;
  listing: React.ReactElement;
  footer: React.ReactElement;
}

export const ListingLayout: React.FC<IListingLayoutProps> = ({ header, filters, listing, footer }) => {
  const deviceType = useDeviceType();

  return (
    <section className={styles.root}>
      <header className={styles.header}>{header}</header>
      <div className={styles.filters}>{filters}</div>
      <main className={cn(styles.main, styles[deviceType])}>
        <div className={styles.container}>{listing}</div>
      </main>
      <footer className={styles.footer}>{footer}</footer>
    </section>
  );
};

ListingLayout.displayName = 'ListingLayout';
